module.exports = __webpack_public_path__ + "img/zzry.298f428b.png";